import React, { Component, Fragment } from "react";
import { Checkbox, Collapse } from "antd";
import ButtonStep from "./../../ButtonStep";
import _ from "lodash";
import { withRouter } from "react-router-dom";

const RetailerTitle = props => {
  return <div className="p-txt-bold p-mrg-top">{props.label}</div>;
};

const { Panel } = Collapse;

class SurveyStepModeles extends Component {
  // componentWillReceiveProps(nextProps) {
  // 	console.log("componentWillReceiveProps");

  // }

  state = {
    surveyModel: []
  };

  componentDidMount() {
    //load models only if there is no progression

    if (this.props.surveyProgress.model.length !== 0) {
      let surevyModel = this.props.surveyProgress.model;
      let labelModel = [];
      _.forEach(surevyModel, (model, index) => {
        let modelCurrent = _.pick(model, ["retailerName"]);
        labelModel.push(modelCurrent.retailerName);
      });
      this.setState({ surveyModel: labelModel });
      this.props.handleDisabled(false);
    }

    //duplicate
    const location = this.props.location || {};
    const locationParams = location.params || {};
    //TODO move this part to SurveyCreation.js, manage callback from api
    if (locationParams.hasOwnProperty("duplicate") && location.state && location.state.survey) {
      this.loadSurvey();
    }
  }

  /**
   * Load survey
   */
  loadSurvey() {
    const surveyData = this.props.location.state.survey || {};
    surveyData.metier = surveyData.metier || {};
    surveyData.retailer = surveyData.retailer || {};

    //console.log("load survey -->", surveyData)
    const progressData = {
      surveyProgress: {
        statusProgress: false,
        label: "",
        stepCreation: 0,
        periodicity: {},
        model: [],
        locations: [],
        sectors: [],
        pdcs: [],
        regionales: [],
        locationTypes: []
        // surveyTitle: "",
      },
      simulationManager: {}
    };

    //set model
    try {
      const models = this.props.assortmentClient || [];
      const retailerId = surveyData.retailer.idRetailer;
      const surveyModel = surveyData.model || {};
      const surveyModelId = surveyModel._id;

      for (let i = 0; i < models.length; i++) {
        const model = models[i];
        if (model._id === surveyModelId) {
          const formattedModel = {};
          formattedModel._id = model._id;
          formattedModel.assortmentLabel = model.assortmentLabel;
          formattedModel.periodicity = model.periodicity;
          formattedModel.products = model.allProducts;
          formattedModel.ranges = model.allRanges;
          formattedModel.locations = model.allLocationTypes;
          formattedModel.categories = model.allCategories;
          formattedModel.locationsStructure = model.locationsStructure;
          formattedModel.client = model.client;
          formattedModel.retailer = model.retailer;
          formattedModel.idRetailer = model.retailer.idRetailer;
          formattedModel.retailerName = model.retailer.retailerName;

          progressData.surveyProgress.model = progressData.surveyProgress.model || [];
          progressData.surveyProgress.model.push(formattedModel);
        }
      }
    } catch (e) {
      console.log(e);
    }

    //set locations, locationsTypes
    try {
      const locationTypes = surveyData.metier.locationTypes || [];
      progressData.surveyProgress.locationTypes = locationTypes;

      //add end visit statement if exists
      if (surveyData.metier.end_visit_statement) {
        progressData.surveyProgress.end_visit_statement = surveyData.metier.end_visit_statement;
      }

      for (let i = 0; i < locationTypes.length; i++) {
        const locationType = locationTypes[i];
        progressData.surveyProgress.locations.push({
          label: locationType.locationType,
          locationTypeId: locationType.locationTypeId,
          statements: []
        });
      }
    } catch (e) {}

    //set locations, locationsTypes
    try {
      for (let i = 0; i < surveyData.sectors.length; i++) {
        const sector = surveyData.sectors[i];
        progressData.surveyProgress.sectors.push({
          label: sector.label,
          sector_id: sector.sector_id,
          sector_label: sector.sector_label
        });
      }
    } catch (e) {}

    progressData.surveyProgress.pdcs = surveyData.pdcs || [];
    progressData.surveyProgress.regionales = surveyData.regionales || [];
    //console.log(progressData, surveyData);
    this.props.loadSurveyProgress(JSON.stringify(progressData));
  }

  onChange = ({ target }) => {
    const checkedValues = [target.value];
    //console.log(checkedValues)
    this.setState({ surveyModel: checkedValues });

    //reset surveyProgress
    let surveyProgress = this.props.surveyProgress;

    //remove step 2/3/4
    surveyProgress.periodicity = {};
    surveyProgress.locations = [];
    surveyProgress.locationTypes = [];
    surveyProgress.secteurs = [];
    surveyProgress.sectors = [];
    surveyProgress.pdcs = [];
    surveyProgress.regionales = [];
    this.props.resetSimulation();

    if (!target.checked) {
      //remove step 1
      surveyProgress.model = [];
      return this.props.addStepSurvey(surveyProgress);
    }

    let modeleList = this.props.modeleList;
    let assortement = this.props.assortmentClient;
    //console.log("assortement", assortement)
    //let modeleList = _.assign([], [this.props.modeleList]);
    let selectModel = [];

    modeleList.filter(modele => {
      checkedValues.filter(actionModele => {
        if (actionModele === modele._id) {
          selectModel.push(modele);
        }
        _.forEach(assortement, (assortement, index) => {
          if (assortement._id === actionModele) {
            _.assign(surveyProgress, { assortments: assortement._id });
            // _.assign(surveyProgress, { surveyTitle: "" });
          }
        });
      });
    });

    let zipModele = _.zipObject(["model"], [selectModel]);
    _.assign(surveyProgress, zipModele);
    this.props.addStepSurvey(surveyProgress);

    if (checkedValues.length < 1) {
      this.props.handleDisabled(true);
    }
    if (checkedValues.length > 0) {
      this.props.handleDisabled(false);
    }
  };

  next = current => {
    //this.props.getLocation(321, this.props.surveyProgress.model[0].idRetailer);
    this.props.storeSurveyProgress();
    this.props.next(current);
  };

  render() {
    const { modeleList, current, steps, sucess, disabled } = this.props;
    const { surveyModel } = this.state;
    //let modeleArrayList = _.assign([], [modeleList]);

    const modelNameSelected =
      this.props.surveyProgress.model[0] && this.props.surveyProgress.model[0]._id
        ? this.props.surveyProgress.model[0]._id
        : null;

    const retailersTitles = [];
    //this.setState({surveyModel:modelNameSelected})

    const modeleListByRetailer = {};
    for (let i = 0; i < modeleList.length; i++) {
      const modeleListElement = modeleList[i];
      if (!modeleListElement || !modeleListElement.retailer_label) continue;
      const retailerName = modeleListElement.retailer_label;
      modeleListByRetailer[retailerName] = modeleListByRetailer[retailerName] || [];
      modeleListByRetailer[retailerName].push(modeleListElement);
    }

    const retailers = Object.keys(modeleListByRetailer);
    return (
      <Fragment>
        <ButtonStep
          current={current}
          steps={steps}
          next={() => this.next(current)}
          sucess={() => sucess(current)}
          disabled={!modelNameSelected}
        />
        <div className="p-txt-italic">- Sélectionner un modèle :</div>
        <div className="p-mrg-bot-l">
          {retailers.map(retailer => {
            const modeles = modeleListByRetailer[retailer] || [];
            return (
              <div>
                <RetailerTitle label={retailer} />
                <div className="p-al-left p-al-wrap">
                  {modeles.map((modele, index) => {
                    const checked = modelNameSelected && modele._id === modelNameSelected;
                    return (
                      <div
                        className={`p-survey-longblock p-mrg-right-s p-mrg-top ${checked ? "selected" : null}`}
                        key={index}
                      >
                        <Checkbox value={modele._id} onChange={this.onChange} checked={checked}>
                          <span className={`${checked ? "p-txt-bold p-clr-blck" : ""}`}>{modele.assortmentLabel}</span>
                        </Checkbox>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </Fragment>
    );
  }
}

export default withRouter(SurveyStepModeles);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepModeles/SurveyStepModeles.js